<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',
  created() {
    // Check if the user is authenticated on app startup
    if (localStorage.getItem('auth_token')) {
      // Check if we have user data in localStorage
      const userData = localStorage.getItem('user_data')

      // If we have a token but no user data, or the user data is incomplete, fetch it
      if (!userData || !JSON.parse(userData).picture) {
        this.fetchUser()
          .catch(() => {// If there's an error fetching user data, clear the token and user data
            localStorage.removeItem('auth_token')
            localStorage.removeItem('user_data')
          })
      }
    }
  },
  mounted() {
    // Most browsers require user interaction before allowing full screen
    // So we'll set up event listeners for the first user interaction

    // Store a reference to the bound method
    this.boundRequestFullScreen = this.requestFullScreen.bind(this);

    // Add event listeners for user interaction to request full screen
    document.addEventListener('click', this.boundRequestFullScreen, { once: true });
    document.addEventListener('touchstart', this.boundRequestFullScreen, { once: true });
    document.addEventListener('keydown', this.boundRequestFullScreen, { once: true });

    // Also try to request full screen on mount (will work on some browsers)
    this.requestFullScreen();
  },
  methods: {
    ...mapActions(['fetchUser']),

    // Function to request full screen mode
    requestFullScreen() {
      // Check if we're already in full screen mode
      if (this.isFullScreen()) {
        return; // Already in full screen, no need to request again
      }

      // Get the document element
      const docEl = document.documentElement;

      // Different browsers have different methods for requesting full screen
      const requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;

      // Check if the browser supports full screen mode
      if (requestFullScreen) {
        try {
          // Request full screen mode
          requestFullScreen.call(docEl);

          // Remove event listeners after successful request
          this.removeFullScreenEventListeners();
        } catch (error) {
          // safe
        }
      }
    },

    // Function to check if we're already in full screen mode
    isFullScreen() {
      return !!(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    },

    // Function to remove event listeners
    removeFullScreenEventListeners() {
      if (this.boundRequestFullScreen) {
        document.removeEventListener('click', this.boundRequestFullScreen);
        document.removeEventListener('touchstart', this.boundRequestFullScreen);
        document.removeEventListener('keydown', this.boundRequestFullScreen);
      }
    },

    // Clean up event listeners when component is destroyed
    beforeDestroy() {
      this.removeFullScreenEventListeners();
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: #f5f5f5;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
}

/* Hide scrollbar for Chrome, Safari and Opera */
body::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbars for all elements */
* {
  scrollbar-width: none;
}

*::-webkit-scrollbar {
  display: none;
}
</style>
